import cache from '../utils/cache';
import validate from '../components/mixins/validate';

export default function () {
    const options = {
        name: 'set-password',
        template: 'templates/set-password.html',
        data() {
            return {
                show: true,
                busy: false,
                password: '',
                confirmPassword: '',
            };
        },
        mixins: [
            validate(),
        ],
        computed: {
            language() {
                const language = this.locale.name;
                return language.toLowerCase();
            },
        },
        methods: {
            isError() {
                const errors = this.errors;
                return (errors.confirmPassword || errors.password);
            },
            close() {
                this.show = false;
            },
            submit() {
                const context = this;
                const im = this.$im();
                const userApi = im.dataModel.User;
                if (context.busy || !context.valid()) {
                    return;
                }
                const oldPassword = cache.get('auth-password');
                const params = {
                    newPassword: this.password,
                    oldPassword,
                };
                context.busy = true;
                // 2019-06-12 密码加密传输 userApi.changePassword 改为 securityChangePassword
                userApi.securityChangePassword(params, (errorCode) => {
                    context.busy = false;
                    if (errorCode) {
                        this.RongIM.common.handleError(errorCode);
                        return;
                    }
                    cache.remove('auth-password');
                    context.close();
                    im.auth.isModifyPwd = false;
                });
            },
        },
    };
    window.RongIM.common.mountDialog(options);
}
